import { BlackoutFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type OperationsAdminVenueTalentBlackoutCreateFragment = Omit<BlackoutFragment, 'id' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'talent' | 'talent_id' >

export const OperationsAdminVenueTalentBlackoutCreateSchema: FormSchema<OperationsAdminVenueTalentBlackoutCreateFragment> = {
    id: "blackout",
    title: "Blackout Date",
    groups: {
        default: {
            label: 'Default' 
        }
    },
   fields: {
        description: {
            group: 'default',
            label: "Description",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        start_at: {
            group: 'default',
            label: "Start At",
            type: "date-time-picker",
            grid: 6,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        end_at: {
            group: 'default',
            label: "Ends At",
            type: "date-time-picker",
            grid: 6,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        }
    }
}

export type OperationsAdminVenueTalentBlackoutUpdateFragment = Omit<BlackoutFragment, 'id' | 'type' |'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'talent' | 'talent_id' >

export const OperationsAdminVenueTalentBlackoutUpdateSchema: FormSchema<OperationsAdminVenueTalentBlackoutUpdateFragment> = {
    id: "blackout",
    title: "Blackout Date",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        description: {
            group: 'default',
            label: "Description",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        start_at: {
            group: 'default',
            label: "Start At",
            type: "date-time-picker",
            grid: 6,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        end_at: {
            group: 'default',
            label: "Ends At",
            type: "date-time-picker",
            grid: 6,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        }
    }
}